module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/338629/particular04-a47cd24f1b4bc3c6e18467e609026a95.png";